import Vue from 'vue';
import App from './App.vue';
import Router from 'vue-router';
import router from '../router/router'; // 引入路由
import axiosInstance from '../axios/axios';  // 引入你自定义的 axios 实例
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale';
import lang from 'element-ui/lib/locale/lang/en'; // 例如使用中文语言包
 
import 'element-ui/lib/theme-chalk/index.css' // 引入 Element UI 样式
// import 'swiper/dist/css/swiper.css' // 引入 Swiper CSS

Vue.use(Router); // 启用 Vue Router
// 设置 axios 的默认 baseURL
Vue.prototype.$axios = axiosInstance;  // 全局注册 axios 实例
Vue.use(ElementUI, { locale });  // 注册 Element UI 插件
locale.use(lang); // 使用 lang 来设置语言环境
Vue.config.productionTip = false


// 在 main.js 或入口文件中定义全局回调
window.onYouTubeIframeAPIReady = function() {
  // 这里可以触发事件通知组件
  window.dispatchEvent(new Event('youtube-api-ready'));
};

// 动态加载 YouTube API
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
new Vue({
  render: (h) => h(App),
  router, // 注册路由
}).$mount('#app');
